import React from "react";
import { FileText } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const isImage = (d) => (d.content_type || "").startsWith("image/");

export const AttachmentList = ({ docs = [], token, testid }) => {
  if (!docs.length) return null;
  const url = (d) => `${API}/files/${d.file_id}?auth=${token}`;
  const images = docs.filter(isImage);
  const files = docs.filter((d) => !isImage(d));
  return (
    <div data-testid={testid}>
      {images.length > 0 && (
        <div className="flex flex-wrap gap-2 mb-2">
          {images.map((d) => (
            <a key={d.file_id} href={url(d)} target="_blank" rel="noreferrer" title={d.label} data-testid={`attachment-image-${d.file_id}`}
              className="block w-20 h-20 rounded-lg overflow-hidden border border-[rgba(19,57,85,0.12)] hover:border-[#54BCE6] transition-colors">
              <img src={url(d)} alt={d.label} loading="lazy" className="w-full h-full object-cover" />
            </a>
          ))}
        </div>
      )}
      {files.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {files.map((d) => (
            <a key={d.file_id} href={url(d)} target="_blank" rel="noreferrer" data-testid={`attachment-file-${d.file_id}`}
              className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#133955] bg-white border border-[rgba(19,57,85,0.12)] rounded-full px-3 py-1.5 hover:border-[#54BCE6]">
              <FileText size={14} /> {d.label}
            </a>
          ))}
        </div>
      )}
    </div>
  );
};
